import { queriesComplianceEntities } from "@query";
import { selectorPrimaryComplianceEntity } from "../selectors/selectorPrimaryComplianceEntity";

/**
 * The account's own compliance entity. Replaces the v2 monitored-entity read
 * (`GET /v2/onboarding/customer`): where that returned a single entity, v3
 * returns a list and the account holder's is the one without a subject.
 *
 * Note the shapes differ — the v2 entity's flat `country` is now the physical
 * address / jurisdiction (see `selectorComplianceEntityCountry`), and a stored
 * tax identifier reads back as a has-value flag only.
 */
export const useQueryPrimaryComplianceEntity = (config?: {
  enabled?: boolean;
}) =>
  queriesComplianceEntities.listComplianceEntities.useQuery(
    {},
    {
      ...config,
      select: response => selectorPrimaryComplianceEntity(response.data)
    }
  );
